var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 14.0833C11.6582 14.0833 14.0833 11.6582 14.0833 8.66667C14.0833 5.67512 11.6582 3.25 8.66667 3.25C5.67512 3.25 3.25 5.67512 3.25 8.66667C3.25 11.6582 5.67512 14.0833 8.66667 14.0833Z",
    fill: "#1890FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66667 1.625C4.77766 1.625 1.625 4.77766 1.625 8.66667C1.625 12.5557 4.77766 15.7083 8.66667 15.7083C10.6114 15.7083 12.3707 14.9211 13.6459 13.6459C14.9211 12.3707 15.7083 10.6114 15.7083 8.66667C15.7083 4.77766 12.5557 1.625 8.66667 1.625ZM0 8.66667C0 3.8802 3.8802 0 8.66667 0C13.4531 0 17.3333 3.8802 17.3333 8.66667C17.3333 10.767 16.5854 12.6938 15.3426 14.1935L19.262 18.113C19.5793 18.4303 19.5793 18.9447 19.262 19.262C18.9447 19.5793 18.4303 19.5793 18.113 19.262L14.1935 15.3426C12.6938 16.5854 10.767 17.3333 8.66667 17.3333C3.8802 17.3333 0 13.4531 0 8.66667Z",
    fill: "#1890FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlue);
export default __webpack_public_path__ + "static/media/search_blue.d6e99a9682b2c6362dbd8d001b2f980f.svg";
export { ForwardRef as ReactComponent };